import { BaseAccount, Client } from '.';

export interface Account extends BaseAccount {
  jobTitle?: string;
  phoneNumber?: string;
  company?: string;
  clientId?: string;
  userId?: string;
  isAdmin?: boolean;
  isActive: boolean;
  client?: Client;
}
